import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import moment from 'moment'
import './Players.css'
import { Schemas } from '../../middleware/api'
import { connectPagination } from '../../decorators'
import { loadTickets } from '../../actions'
import get from 'lodash/get'

import { Table } from '../Generic'
import { Column } from '@rapiddot/react-virtual-list'
import { getTicketPath, formatMoney , getSort } from '../../util'

class TicketsList extends React.Component {

  render() {
    const { pagination, totalItems } = this.props

    return (
      <div className="players-table-wrapper">

        { !totalItems && get(pagination, 'isFetching')  && <div className="table-info-header">Loading Tickets...</div> }
        { this.props.title && <div className="table-title">{this.props.title}</div>}        

        { this.props.totalItems > 0 && <div className="table-info-header">showing {this.props.totalItems} tickets...</div> }

        <Table {...this.props} rowHeight={40} className="generic-table">
          <Column
            label='id'
            dataKey='id'
            cellRenderer={({rowData}) => <Link to={getTicketPath(rowData)}>{rowData.id}</Link>}
            className='small-table-column'
          />

          <Column
            label='delivery date'
            dataKey='delivery_date'
            sortable={true}
            cellRenderer={({rowData}) => moment(rowData.delivery_date).format('DD/MM/YYYY')}
            className='generic-table-column'
          />

          <Column
            label='live'
            dataKey='live'
            className='small-table-column'
          />

          <Column
            label='stake'
            dataKey='total_stake'
            sortable={true}
            cellRenderer={({rowData}) => <div>{formatMoney(rowData.stake)}</div>}
            className='generic-table-column'
          />

          <Column
            label='prize'
            dataKey='prize'
            sortable={true}
            cellRenderer={({rowData}) => <div>{formatMoney(rowData.prize)}</div>}
            className='generic-table-column'
          />

          <Column
            label='status'
            dataKey='status'
            className='generic-table-column'
          />
        </Table>
      </div>
    )
  }
}

const withPagination = connectPagination({
  entitykey: 'tickets',
  loadItems: loadTickets,
  itemSchema: Schemas.TICKET,
  getQueryParams: ({state, ownProps}) => {
    return {
      ordering: '-delivery_date',
      player_id: ownProps.playerId,
      ...state.routing.locationBeforeTransitions.query
    }
  },
  title: 'Players Pagination',
})(TicketsList)

export const Tickets = connect(
  (state, ownProps) => ({
    playerId: ownProps.params.playerId,
    location: ownProps.location,
    ...getSort(get(ownProps, 'location.query.ordering', '-delivery_date'))
  }),
  { loadTickets }
)(withPagination)


// WEBPACK FOOTER //
// ./src/components/Players/Tickets.js